import React from "react";
import boardService from "../services/boardService";
import Relation from "../cmps/Relation";
import Loader from "../cmps/MondayLoader";
import { AttentionBox } from "monday-ui-react-core";

export default function RelationController({
  sessionToken,
  userId,
  user,
  loading,
  boards,
  relations,
  setRelations,
  monday
}) {


  const deleteRelation = async (relation, state, setCountDeletion) => {
    state({ delete: true });
    try {
      await boardService.deleteRelation(relation, sessionToken, setCountDeletion);
      const filteredRelations = relations.filter(
        (boardRelation) => boardRelation._id !== relation._id
      );
      setRelations(filteredRelations);

      monday.execute('notice', {
        message: `Relation deleted successfuly!`,
        type: 'success',
        timeout: 8000,
      })


    } catch(err) {
      console.log('file: RelationController.jsx:27 -> err:', err)
      monday.execute('notice', {
        message: `Error on deleting relation`,
        type: 'error',
        timeout: 8000,
      })
    } finally {
      state({ delete: false });

    }

  };

  const isLicenseExpired = user?.license !== 'enterprise' && user?.license !== 'free-trial'
  const warningText = user?.license === 'expired-enterprise' ? 'Your license has expired' : 'Free trial has ended'

  if(relations && !relations.length) 
  return (
    <section className="error-message">
      <AttentionBox text={'There are no relations to display.'} title={'Attention'} />
    </section>
  )
  return (
    <>

    <section className="relation-controller-container">
      <div className="relation-controller">
        <h3> Edit existing relations</h3>
        {isLicenseExpired && (
          <p className="warning-msg">
            {warningText}
          </p>
        )}
        {loading ? (
          <Loader />
          ) : (
            <div className="edit-boards">
            {relations &&
              relations?.map((relation, i) => (
                <Relation
                sessionToken={sessionToken}
                deleteRelation={deleteRelation}
                key={i}
                relation={relation}
                boardNames={boards}
                boards={boards}
                userId={userId}
                isMulti={relation.isMulti}
                isLicenseExpired={isLicenseExpired}
                monday={monday}
                />
                ))}
          </div>
        )}
      </div>
    </section>
        </>
  );
}
